<template>
  <!-- 详情 -->
  <div class="about">
	<!-- 内容1 -->
<el-row :gutter="24">
	<el-col :span="6" :offset="3"><div class="left"><h3>课程列表</h3></div></el-col>
	<el-col :span="12"><div class="right">
	<ul>
		<li>查看公开课</li>
		<li>查看班级</li>
	</ul>
	</div></el-col>
	</el-row>
	<!-- 内容2 -->
	<el-row>
	<el-col :span="18" :offset="3"><div class="nav"><span>所有分类:</span></div></el-col>
	</el-row>
	<!-- 内容3 -->
	<el-row>
	<el-col :span="18" :offset="3"><div class="nav_title">
	<ul>
		<li>分类:</li>
		<li :class="{active:cuss==0}" @click="cuss=0">全部</li>
		<li :class="{active:cuss==1}" @click="cuss=1">产品介绍</li>
		<li :class="{active:cuss==2}" @click="cuss=2">使用教程</li>
		<li :class="{active:cuss==3}" @click="cuss=3">默认分类</li>
	</ul>
	</div></el-col>
	</el-row>
	<!-- 内容4 -->
	<el-row>
	<el-col :span="18" :offset="3"><div class="title2">
	
	<el-col :span="6"><div class="title2_left">
	<ul>
		<li :class="{active:bcg==0}" @click="bcg=0">最新</li>
		<li :class="{active:bcg==1}" @click="bcg=1">最热</li>
		<li :class="{active:bcg==2}" @click="bcg=2">推荐</li>
	</ul>
	</div></el-col>
	<el-col :span="6" :offset="12"><div class="title2_right">
	<el-checkbox v-model="checked1" @click="!checked1">直播课程</el-checkbox>
	<el-checkbox v-model="checked2" @click="!checked2">免费课程</el-checkbox>
	</div></el-col>
	</div></el-col>
	</el-row>
	<!-- 内容部分 -->
	<el-row>
	<el-col :span="18" :offset="3"><div class="about_content">
	<ul>
		<li v-for="item in 12" :key="item">
			<div class="list">
				<img src="#" alt="">
				<p>课程指南</p>
				<p>课程指南</p>
				<p>免费</p>
			</div>
		</li>
	</ul>
	</div></el-col>
	</el-row>
  </div>
</template>

<script>
export default {
	name:'about',
	data () {
return {
	cuss:'0',
	bcg:0,
	checked1: true,
	checked2: true
}
},
mounted() {
}
}
</script>

<style scoped lang="scss">
.about {
	width: 98%;
	margin: 0rem auto;
	.left,.right {
		height: 5rem;
		// background-color: red;
		background-color: #FFFFFF;
		margin-left: 0rem;
	}
	.left>h3 {
		float: left;
		line-height: 5rem;
		font-weight: 500;
		color: #46C37B;
	}
	.right {
		ul {
			float: right;
			margin-top: 20px;
			li {
				width: 6.25rem;
				height: 2.5rem;
				// background-color: yellow;
				line-height: 2.5rem;
				position: relative;
				border-radius: 0.3125rem;
				background-color: #46c37b;
			}
			li:first-child {
				margin-right: 10px;
			}
			li:hover {
				background-color: #34a263;
			}
		}
	}
	// 
	.nav {
		height: 2.5rem;
		background-color: #F0F7FF;
		border-bottom: 1px solid #D9D9D9;
		text-align: left;
		line-height: 2.5rem;
		span {
			margin-left: 0.625rem;
		}
	}
	// 
	.nav_title {
		text-align: left;
		height: 2.5rem;
		line-height: 2.5rem;
		background-color: #F0F7FF;
		ul {
			float: left;
			margin-left: 0.625rem;
			.active {
				color: #13CE66;
			}
			li {
				display: inline-block;
				margin-right: 1.25rem;
			}
		}
	}
	// 
	.title2 {
		height: 2.5rem;
		background-color: #F0F7FF;
		margin-top: 2.5rem;
		.title2_left {
			height: 2.5rem;
			// background-color: red;
			line-height: 2.5rem;
			ul {
				float: left;
				.active {
					background-color: #46c37b;
				}
				li {
					float: left;
					color: #616161;
					display: inline-block;
					width: 5rem;
					height: 2.5rem;
				}
			}
		}
		.title2_right {
			height: 2.5rem;
			// background-color: red;
			line-height: 2.5rem;
		}
	}
	// 内容
	.about_content {
		height: 37.5rem;
		background-color: #FFFFFF;
		border: 0.0625rem solid  #e4ecf3;
		margin-top: 2.5rem;
		ul {
			width: 98%;
			height: 100%;
			
			margin: 0rem auto;
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			li {
				width: 23%;
				height: 20%;
				// background-color: red;
				border: 0.0625rem solid  #e4ecf3;
				margin-top: 1.25rem;
				transition: all 0.5s;
				.list {
					width: 100%;
					height: 100%;
					position: relative;
					img {
						left: 0.625rem;
						top: 0.625rem;
						width: 3.75rem;
						height: 3.75rem;
						background-color: #DCDCDC;
						position: absolute;
					}
					p {
						position: absolute;
					}
					p:first-of-type {
						left: 6.25rem;
						top: 0.625rem;
						color: #46c37b;
					}
					p:nth-of-type(2) {
						left: 0.625rem;
						top: 5rem;
						
						font-weight: 500;
					}
					p:nth-of-type(2):hover {
						color: #46c37b;
					}
					p:last-of-type {
						bottom: 1.25rem;
						right: 1.25rem;
						color: #46c37b;
					}
				}
			}
			li:hover {
				box-shadow: 0rem 20px 20px #DCDCDC;
				margin-top: 0.625rem;
			}
		}
	}
}
</style>
